import type {
  PriceListItemCalculateType,
  PriceListResource,
  ProductPriceListItem,
} from "@exonn/js-sdk";

export const computePriceListItemFromPriceList = ({
  priceList,
}: {
  priceList: PriceListResource;
}): ProductPriceListItem | undefined => {
  if (priceList.calculate_type === null) {
    return undefined;
  }

  return {
    calculate_type:
      priceList.calculate_type as unknown as PriceListItemCalculateType,
    is_calculate_round: priceList.is_calculate_round,
    calculate_from: priceList.calculate_from,
    calculate_value: priceList.calculate_value,
  };
};
